export const MEDICAL_HEALTH_INFORMATION_NAME = 'MedicalHealthInformation';
export const MEDICAL_HEALTH_INFORMATION_BRANCH_NAME = 'MedicalHealthInformationBranch';
export const MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME =
  'MedicalHealthInformationBranchQuestionnaireResponse';
export const MEDICAL_HEALTH_INFORMATION_DETAIL_NAME = 'MedicalHealthInformationDetail';
export const MEDICAL_HEALTH_INFORMATION_ERROR_NAME = 'MedicalHealthInformationError';
export const UNANSWERED = '未回答';
export const ALREADY_ANSWERED = '回答済み';
export const MEDICAL_RECORDS = '診療記録';
export const DISP_MORE_VIEW_BUTTON_COUNT = 8;
export const INFO_KUBUN = {
  PATIENT: '1',
  PRACTITIONER: '2'
};
export const STATUS_COLOR = {
  [UNANSWERED]: {
    marginLeft: '8px',
    color: 'white',
    backgroundColor: '#D32F2F',
    borderRadius: '4px',
    padding: '1px 6px'
  },
  [ALREADY_ANSWERED]: {
    marginLeft: '8px',
    color: 'white',
    backgroundColor: '#424242',
    borderRadius: '4px',
    padding: '1px 6px'
  },
  [MEDICAL_RECORDS]: {
    marginLeft: '8px',
    color: 'white',
    backgroundColor: '#3582BC',
    borderRadius: '4px',
    padding: '1px 6px'
  }
};
